export const FILTER_CONFIG = {
    "vertical": {
        categories: {
            title: "CATEGORIES",
            accessor: "categories",
            stateKey: "categories",
        },
        brands: {
            title: "BRANDS",
            accessor: "brands",
            stateKey: "brands",
        },
        colors: {
            title: "COLORS",
            accessor: "colors",
            stateKey: "colors",
        }
    },
    "category": {
        subcategory: {
            title: "CATEGORIES",
            accessor: "subCategories",
            stateKey: "categories",
        },
        brands: {
            title: "BRANDS",
            accessor: "brands",
            stateKey: "brands",
        },
        colors: {
            title: "COLORS",
            accessor: "colors",
            stateKey: "colors",
        }
    },
    "subcategory": {
        brands: {
            title: "BRANDS",
            accessor: "brands",
            stateKey: "brands",
        },
        colors: {
            title: "COLORS",
            accessor: "colors",
            stateKey: "colors",
        }
    },
};